import React, { useState, createContext, useContext } from 'react';
import { LoginContext } from 'src/lib/LoginContext';

interface IAccountContext {
  getAccount: Function;
  account: {
    BusinessName: string,
    ClientID: number,
    Emails: {
      Active: number,
      Email: string,
      EmailID: number,
      EmailReplaceID: string,
      EmailType: string,
      EmailTypeID: number,
    }[],
    FirstName: string,
    GenreID: number,
    LastName: string,
    MI: string,
    Nickname: string,
    Role: string,
    Sirname: string,
  };
  getAdmin: Function;
  isAdmin: boolean;
}

export const AccountContext = createContext<Partial<IAccountContext>>({});

export const AccountContextConsumer = AccountContext.Consumer;

export const AccountContextProvider = ({ children }) => {
  const [account, setAccount] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const { isLoggedIn } = useContext(LoginContext);

  const getAccount = async () => {
    if(!isLoggedIn) return;
    const accountReq = await fetch('/api/account/info/accountInfo', { credentials: 'include' });
    const account = await accountReq.json();
    const emailReq = await fetch('/api/account/email/getAll', { credentials: 'include' });
    const email = await emailReq.json();
    const emails = email.filter((e) => e.EmailType === 'Primary');

    if(account.length > 0) {
      account[0].Emails = emails;
      setAccount(account[0]);
    }
  };

  const getAdmin = async () => {
    // Check for admin status
    try {
      const req = await fetch('/api/ghost/getBlogAdmin', { credentials: 'include' });
      const res = await req.json();
      setIsAdmin(res.success ? true : false);
    } catch (e) {
      console.error('Failed to get admin status', e);
      setIsAdmin(false);
    }
  };

  return (
    <AccountContext.Provider value={{
      getAccount,
      account,
      getAdmin,
      isAdmin,
    }}>
      {children}
    </AccountContext.Provider>
  );
};
